export default __webpack_public_path__ + "static/trusted-641425b464e686cd22e96e5db7609d38.png";